export const imgSrc = (url = '/') => {
  const prefix = import.meta.env['VITE_ASSETS_PREFIX'] ?? 'https://admin.uberi.pro';
  if (url.startsWith('http')) return url;
  if (prefix) return prefix + url;
};

export const isDev = () => import.meta.env.MODE === 'development';
export const replaceKeys = (city, text) => {
  const keys = ['header', 'phone', 'url', 'email'];

  for (var key of keys) {
    var re = new RegExp(`\\+#city\\.${key}`, 'g');
    const replacer = city[key];
    text = text.replace(re, replacer);
  }

  return text;
};

export * from './interface/index';
export * from './widgets/index';
export * from '../shared/index';
export { default as store } from './store';
